import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '@/hooks/use-stores';
import EPIconButton from '@/components/EPButton/EPIconButton';
import CloseIcon from '@/comp/common/icons/CloseIcon';
import MinimizeIcon from '@/comp/common/icons/MinimizeIcon';
import { useDeviceDrawerActions } from '@/hooks/useDeviceDrawerActions';

import ActivityIndication from '../../DetailsDrawer/ActivityIndication/ActivityIndication';
import { MinimizedViewContainer } from './MinimizedView.styles';
import PoweredOnIndication from '../../DetailsDrawer/PoweredOnIndication/PoweredOnIndication';
import LabelValue from '../../DetailsDrawer/Tabs/AssetInfo/LabelValue/LabelValue';
import { getAssetNameDetails, getConnectivityIcon } from '../../DetailsDrawer/DetailsDrawer.utils';
import { useMinimizedViewLabelValueItemsByDeviceType } from './MinimizedView.utils';

const MinimizedView = observer(() => {
  const { t } = useTranslation();
  const { mapBuilderStore, stationStore } = useStores();
  const { closeDeviceDrawer } = useDeviceDrawerActions();
  const entity = mapBuilderStore.selectedDevice ?? {};
  const labelValueItems = useMinimizedViewLabelValueItemsByDeviceType(entity);

  const currentAsset = stationStore.assetsDevices?.find(
    device => device.deviceId === mapBuilderStore.selectedDevice?.deviceId,
  );

  const Icon = getConnectivityIcon(entity.deviceType, entity, currentAsset, t);

  return (
    <MinimizedViewContainer>
      <div className="header">
        <div className="left">
          {Icon}
          <div className="device-info">
            <div className="device-name">{entity.name}</div>
            <div className="device-model">{getAssetNameDetails(entity)}</div>
          </div>
        </div>
        <div className="right">
          <ActivityIndication entity={entity} />
          <PoweredOnIndication entity={entity} />
          <div className="drawer-details-header-buttons">
            <EPIconButton icon={<MinimizeIcon />} onClick={mapBuilderStore.maximizeModal} />
            <EPIconButton icon={<CloseIcon />} onClick={closeDeviceDrawer} />
          </div>
        </div>
      </div>
      <div className="body">
        {labelValueItems.map(item => (
          <LabelValue
            key={item.label}
            label={item.label}
            value={item.value}
            unit={item.unit}
            prefix={item.prefix}
            suffix={item.suffix}
          />
        ))}
      </div>
    </MinimizedViewContainer>
  );
});

export default MinimizedView;
